import { useCallback, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import styles from './style.module.css';

import { Button } from '../../components/Button';
import { List, ListItem } from '../../components/List';
import { Loading } from '../../components/Loading';

import * as routes from '../../constants/Routes';
import { useAuth } from '../../hooks/useAuth';
import { api } from '../../server/api';

import iconPontosResgatados from '../../assets/images/icon-pontos-resgatados.png';
import iconPontosTotais from '../../assets/images/icon-pontos-totais.png';
import iconPontosPendentes from '../../assets/images/icon-pontos-pendentes.png';
import iconSaldoPontos from '../../assets/images/icon-saldo-pontos.png';

import { PlayerAvatar } from '../../components/PlayerAvatar';
import banner from '../../assets/images/banner.jpeg';
import { shortenNumber } from '../../utils/ShortenNumber';
import moment from 'moment';
import { Card } from '../../components/Card';
import { HelmetComponent } from '../../components/Helmet';
import { numberWithCommas } from '../../utils/numberWithCommas';
import { ModalGoal } from './components/ModalGoal';
import { IAwards } from '../../interfaces/IAwards';
import { IGetMedals, IMedal } from '../../interfaces/IMedals';
import { usePoints } from '../../hooks/usePoints';
import { useTransaction } from '../../hooks/useTransaction';
import { HierarchyLeadership } from '../../features/hierarchy/components/HierarchyLeadership/HierarchyLeadership';

export function Profile() {
  const { client, player } = useAuth();
  const { getPoints, redeemedPoints, totalPoints, availableToRedeem } =
    usePoints();
  const { getLastTransaction, lastTransaction } = useTransaction();
  const navigate = useNavigate();
  const [awards, setAwards] = useState<Array<IAwards>>([]);
  const [fiveAwards, setFiveAwards] = useState<Array<IAwards>>([]);
  const [isLoadingProfile, setIsLoadingProfile] = useState<boolean>(true);
  const [isViewAll, setIsViewAll] = useState<boolean>(false);
  const [isOpenModalMeta, setIsOpenModalMeta] = useState<boolean>(false);
  const [percentGoal, setPercentGoal] = useState<number>(0);
  const [medals, setMedals] = useState<IGetMedals>();
  const [playerMedals, setPlayerMedals] = useState<IMedal>();

  const toggleModalMeta = () => {
    setIsOpenModalMeta(!isOpenModalMeta);
  };

  useEffect(() => {
    async function loadProfile() {
      if (
        client?.scaleEnable === 'true' &&
        client?.mgmVinculated &&
        client?.mgmVinculated === 'true' &&
        player?.regional === 'sim'
      ) {
        await getMonthlyGoal();
      }
      await getAwards();

      setIsLoadingProfile(false);
    }

    loadProfile();
  }, [client]);

  useEffect(() => {
    async function loadMedals() {
      await getMedals();
      await getPlayerMedals();
      await getLastTransaction('PENDING_POINTS');
    }
    client?.scaleEnable === 'true' &&
      client?.mgmVinculated &&
      client?.mgmVinculated === 'true' &&
      player?.regional === 'sim' &&
      verifyIsShowModalGoal();
    loadMedals();
    getPoints(client?.clientUrl, player?.id);
  }, [client, player]);

  const getMedals = useCallback(async () => {
    try {
      const { data } = await api.get(
        `/clients/${client?.clientUrl}/medals-settings`
      );
      if (data.body) {
        data.body.tiers.sort((a, b) => a.start - b.start);
        setMedals(data.body);
      }
    } catch (error) {
      console.log('error getMedals: ', error);
    }
  }, [client]);

  const getPlayerMedals = useCallback(async () => {
    try {
      const { data } = await api.get(
        `/medals/${client?.clientUrl}/${player?.id}`
      );
      if (data.body) setPlayerMedals(data.body);
    } catch (error) {
      console.log('error getPlayerMedals: ', error);
    }
  }, [client, player]);

  const getMonthlyGoal = useCallback(async () => {
    try {
      const parameters = {
        searchFunctionality: 'getMonthlyGoal',
        userType: 'player',
        clientId: client?.id,
      };

      const { data } = await api.post('/search', parameters);

      if (data.success) {
        setPercentGoal(data.data);
      }
    } catch (error) {
      console.log('getMonthlyGoal error: ', error);
    }
  }, [client]);

  const getAwards = useCallback(async () => {
    try {
      const parameters = {
        searchFunctionality: 'getNotGamifiedAwards',
        userType: 'player',
        clientId: client && client.id,
        playerId: player?.id,
      };

      const { data } = await api.post('/search', parameters);

      if (data.success) {
        const { awards } = data.data;
        const sliceAwards = awards.slice(0, 5);

        setAwards(awards);

        if (awards.length > 5) {
          setFiveAwards(sliceAwards);
        }
      }
    } catch (error) {
      console.log('getAwards error: ', error);
    }
  }, []);

  const verifyIsShowModalGoal = () => {
    /*
      * busca a data que tem no localstorage
      * se nao tiver, seta o modal como true e adiciona a data atual
      * se tiver, então calcula a diferença de dias entre a data que foi setada
        e a data atual
      * se a diferença for menor que 1 semana, continua sem mostrar o modal, senão
        mostra o modal novamente e seta uma nova data
    */
    const localDateShowGoal = localStorage.getItem('dateShowGoal');

    if (!localDateShowGoal) {
      const newDate = moment().valueOf();
      localStorage.setItem('dateShowGoal', newDate.toString());
      setIsOpenModalMeta(true);
    }
    const dateValueOf = moment(
      moment(Number(localDateShowGoal)).format('YYYY-MM-DD'),
      'YYYY-MM-DD'
    );
    const valueOf = moment().valueOf();

    const now = moment(moment(valueOf).format('YYYY-MM-DD'), 'YYYY-MM-DD');

    const diffOfDays = moment.duration(now.diff(dateValueOf)).asDays();
    if (diffOfDays < 7) {
      setIsOpenModalMeta(false);
    } else {
      const newDate = moment().valueOf();
      localStorage.setItem('dateShowGoal', newDate.toString());
      setIsOpenModalMeta(true);
    }
  };

  const handleViewAll = () => {
    setIsViewAll(!isViewAll);
  };

  const onHandleEditProfile = () => {
    navigate(routes.EDIT_PROFILE);
  };

  const onHandleMyIndications = () => {
    navigate(routes.MY_INDICATIONS);
  };
  const onHandleMyProspects = () => {
    navigate(routes.PROSPECTS);
  };
  const onHandleMyBenefits = () => {
    navigate(routes.MY_BENEFITS);
  };
  const onHandleRanking = () => {
    navigate(routes.RANKING);
  };
  const onHandleMyRescues = () => {
    navigate(routes.MY_RESCUES);
  };
  const onHandleMyEngagements = () => {
    navigate(routes.MY_ENGAGEMENTS);
  };

  if (isLoadingProfile) {
    return <Loading />;
  }

  return (
    <>
      <HelmetComponent
        clientLogoURL={client?.logoURL}
        companyName={client?.companyName}
        clientFavicon={client?.favIcon}
        primaryColor={client?.primaryColor}
        secondaryColor={client?.secondaryColor}
        tabTitle={'Perfil'}
      />
      <div className="my-3">
        <div className={styles.coverHead}>
          <img src={client?.backgroundPlayerImage || banner} alt="" />
          <div className={styles.coverWrapperProfile}>
            <PlayerAvatar
              photoURL={player?.photoURL}
              size={100}
              style={{ top: -50, backgroundColor: '#eee', borderRadius: '50%' }}
              imgStyle={{ border: '4px solid var(--background)' }}
            />
          </div>
        </div>
      </div>

      <div className="container">
        <div
          className={`d-flex align-items-center flex-column ${styles.infoUserWrapper}`}
        >
          <p className={`m-0 ${styles.profileName}`}>{player && player.name}</p>
          <p className={`m-0 opacity-75 ${styles.profileSubtitle}`}>
            {player && player.email}
          </p>
          <div className="mt-3">
            <Button
              onClick={onHandleEditProfile}
              icon="edit"
              text="Editar perfil"
              color="primary"
            />
          </div>
        </div>

        <div className="row">
          <div className="col">
            <div className="d-grid mb-2">
              <Button
                icon="import_contacts"
                text={'Meus treinamentos'}
                onClick={() => navigate(routes.TRAININGS)}
              />
            </div>
          </div>

          {client?.isGamified === 'true' && (
            <div className="col">
              <div className="d-grid mb-2">
                <Button
                  icon="show_chart"
                  text="Ranking"
                  onClick={onHandleRanking}
                />
              </div>
            </div>
          )}

          {client?.moduleBenefits === 'true' && (
            <div className="col">
              <div className="d-grid mb-2">
                <Button
                  icon="verified"
                  text={
                    client.buttonNameBenefit !== ''
                      ? client.buttonNameBenefit
                      : 'Benefícios'
                  }
                  onClick={onHandleMyBenefits}
                />
              </div>
            </div>
          )}

          {client?.moduleIndications === 'true' && (
            <div className="col">
              <div className="d-grid mb-2">
                <Button
                  icon="people"
                  text={
                    player?.regional === 'sim' ? 'Meus leads' : 'Meus indicados'
                  }
                  onClick={onHandleMyIndications}
                />
              </div>
            </div>
          )}

          {client.settings?.statement?.enabled && (
            <>
              <div className="col">
                <div className="d-grid mb-2">
                  <Button
                    icon="subject"
                    text="Extrato"
                    onClick={() => navigate(routes.STATEMENT)}
                  />
                </div>
              </div>
            </>
          )}

          {client && client.moduleEngagements === 'true' && (
            <div className="col">
              <div className="d-grid mb-2">
                <Button
                  icon="workspace_premium"
                  text="Engajamento"
                  onClick={onHandleMyEngagements}
                />
              </div>
            </div>
          )}

          {client &&
            client?.mgmVinculated === 'true' &&
            player?.regional === 'sim' && (
              <div className="col">
                <div className="d-grid mb-2">
                  <Button
                    icon="groups_2"
                    text="Prospectores"
                    onClick={onHandleMyProspects}
                  />
                </div>
              </div>
            )}

          {client?.mgmVinculated === 'true' && player?.regional === 'sim' && (
            <div className="col">
              <Link to={routes.RESULTS}>
                <div className="d-grid mb-2">
                  <Button icon="stars" text="Ranking" />
                </div>
              </Link>
            </div>
          )}
        </div>

        <div className="row mt-3">
          <div className="col-12 col-md-6">
            <div className="mb-3 mb-md-0">
              <Card>
                <span
                  className={`${styles.areaCardTitle} d-flex pb-3 fw-semibold`}
                >
                  Prêmios que você pode ganhar
                </span>
                <List>
                  {!isViewAll && fiveAwards.length === 5 ? (
                    <>
                      {fiveAwards &&
                        fiveAwards.map((award) => (
                          <ListItem
                            key={award.premiumId}
                            content={award.premiumName}
                            image={award.premiumImage}
                          />
                        ))}
                    </>
                  ) : (
                    <>
                      {awards &&
                        awards.map((award) => (
                          <ListItem
                            key={award.premiumId}
                            content={award.premiumName}
                            image={award.premiumImage}
                          />
                        ))}
                    </>
                  )}
                </List>
                <div className="d-flex justify-content-center mt-4 gap-3">
                  <Button
                    icon="workspace_premium"
                    text="Meus Resgates"
                    onClick={onHandleMyRescues}
                  />
                  {fiveAwards && fiveAwards.length === 5 && (
                    <Button
                      onClick={handleViewAll}
                      text={`Ver ${!isViewAll ? 'todos' : 'menos'}`}
                      color="flat"
                      icon="add"
                    />
                  )}
                </div>
              </Card>
            </div>
          </div>
          <div className="col-12 col-md-6">
            <div className="mb-3 mb-md-0">
              <Card>
                {player && player.hostId && (
                  <div className="mb-3">
                    <span
                      className={`${styles.areaCardTitle} d-flex pb-3 fw-semibold`}
                    >
                      Convidado(a) por:
                    </span>
                    <List>
                      <ListItem
                        content={player && player.playerNameHost}
                        icon="link"
                        secondaryContent={player && player.playerEmailHost}
                      />
                    </List>
                  </div>
                )}
                {medals?.enabled && player?.regional == 'sim' && medals && (
                  <>
                    <p className={`fw-semibold m-0`}>Nível/Status</p>
                    <span className="tiny-text m-0">
                      {medals?.description
                        ? medals?.description
                        : 'As medalhas indicam o seu nível/status no programa.'}
                    </span>
                    <div className="mb-3">
                      <List>
                        <ListItem
                          content="Seu status/nível"
                          image={
                            playerMedals?.imageUrl ? playerMedals?.imageUrl : ''
                          }
                          icon={!playerMedals?.imageUrl ? 'emoji_events' : ''}
                          secondaryContent={`Nível ${playerMedals?.name ? playerMedals?.name : '-'}`}
                          expansible={medals?.tiersVisibleInPwa !== false}
                          styleIcon="outlined"
                          contentExpansible={
                            <List>
                              {medals?.tiers.map((tier, index) => {
                                return (
                                  <ListItem
                                    key={index}
                                    content={tier.name}
                                    image={tier?.imageUrl ? tier?.imageUrl : ''}
                                    icon={!tier?.imageUrl ? 'emoji_events' : ''}
                                    styleIcon="outlined"
                                    secondaryContent={
                                      client?.clientUrl !== 'magikjc'
                                        ? `${
                                            index === medals?.tiers.length - 1
                                              ? `Acima de ${
                                                  client?.settings?.medals
                                                    ?.targetField === 'vgv'
                                                    ? 'R$'
                                                    : ''
                                                } ${shortenNumber(tier.range.starts)}`
                                              : `De ${
                                                  client?.settings?.medals
                                                    ?.targetField === 'vgv'
                                                    ? 'R$'
                                                    : ''
                                                } ${shortenNumber(tier.range.starts)} a ${
                                                  client?.settings?.medals
                                                    ?.targetField === 'vgv'
                                                    ? 'R$'
                                                    : ''
                                                }${shortenNumber(tier.range.ends)}`
                                          } ${
                                            client?.settings?.medals
                                              ?.targetField === 'admissionDate'
                                              ? 'meses'
                                              : '(VGV)'
                                          }`
                                        : undefined
                                    }
                                  />
                                );
                              })}
                            </List>
                          }
                        />
                      </List>
                    </div>
                  </>
                )}

                <HierarchyLeadership playerId={player?.id} />

                <span
                  className={`${styles.areaCardTitle} d-flex pb-3 fw-semibold`}
                >
                  {client?.coinName
                    ? client.coinName.replace(
                        /\((\w+)\)/,
                        (_, conteudo) => conteudo
                      )
                    : 'Pontos'}
                </span>
                <List>
                  <ListItem
                    content={`${client?.coinName ? client.coinName.replace(/\((\w+)\)/, (_, conteudo) => conteudo) : 'Pontos'} resgatados`}
                    image={iconPontosResgatados}
                    secondaryContent={
                      redeemedPoints
                        ? numberWithCommas(redeemedPoints.toFixed(2))
                        : (0).toFixed(2)
                    }
                  />
                  <ListItem
                    content={`Saldo de ${client?.coinName ? client.coinName.replace(/\((\w+)\)/, (_, conteudo) => conteudo) : 'pontos'}`}
                    image={iconSaldoPontos}
                    secondaryContent={
                      availableToRedeem
                        ? numberWithCommas(availableToRedeem.toFixed(2))
                        : numberWithCommas((0).toFixed(2))
                    }
                  />
                  <ListItem
                    content={`${client?.coinName ? client.coinName.replace(/\((\w+)\)/, (_, conteudo) => conteudo) : 'Pontos'} totais`}
                    image={iconPontosTotais}
                    secondaryContent={
                      totalPoints
                        ? numberWithCommas(totalPoints.toFixed(2))
                        : (0).toFixed(2)
                    }
                  />
                  {client?.settings?.redemptionPolicy && (
                    <ListItem
                      content={`${client?.coinName ? client.coinName.replace(/\((\w+)\)/, (_, conteudo) => conteudo) : 'Pontos'} pendentes`}
                      image={iconPontosPendentes}
                      secondaryContent={
                        lastTransaction?.balance
                          ? numberWithCommas(
                              lastTransaction?.balance.toFixed(2)
                            )
                          : numberWithCommas((0).toFixed(2))
                      }
                    />
                  )}
                </List>
              </Card>
            </div>
          </div>
        </div>
        {/* Fim Detalhes do usuário */}
      </div>

      <ModalGoal
        toggleModal={toggleModalMeta}
        modalIsOpen={isOpenModalMeta}
        percentage={Math.round(percentGoal)}
      />
    </>
  );
}
